export const SHOW_HELP = 'SHOW_HELP';
export const showHelp = (helpLocation, opts) => {
  const { actsAsToggle, tab } = opts ?? {};

  return {
    type: SHOW_HELP,
    payload: { helpLocation, actsAsToggle, tab },
  };
};

export const HIDE_HELP = 'HIDE_HELP';
export const hideHelp = () => ({ type: HIDE_HELP });

export const SET_CURRENT_PAGE_HELP = 'SET_CURRENT_PAGE_HELP';
export const setCurrentPageHelpLocation = helpLocation => ({
  type: SET_CURRENT_PAGE_HELP,
  payload: helpLocation,
});

export const SET_CURRENT_HELP_TAB = 'SET_CURRENT_HELP_TAB';
export const setCurrentTab = newCurrentTab => ({
  type: SET_CURRENT_HELP_TAB,
  payload: newCurrentTab,
});
